<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system/index';
	import { capFirstChar } from 'src/helpers/utilities';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<Alert
	class="mb-s"
	heading={$format('alert_device_configure_peripherals', {
		default: `Configure Peripherals`,
	})}
	message={$format('alert_device_configure_peripherals_message', {
		default: 'Please, setup the desired mode and connect your addons.',
	})}
	isHeadingBold
	cta={{
		title: capFirstChar(
			$format('button_peripheral_settings', {
				default: 'Peripherals settings',
			}),
		),
	}}
	on:cta_click={() => {
		navigateToSetting(device.id, 'pill_peripheral_settings', 'pill_peripheral_settings');
	}}
/>
